/* eslint-disable global-require,import/no-unresolved,max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'react-native'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import CommunicatorSetupStep from './CommunicatorSetupStep'
import textStyles from '../../styles/text'
import * as tapevent from '../../actions/tapEvents'
import * as helpers from '../../actions/helpers'
import * as regionalLookup from '../methods/RegionalContentLookUp'
import Hyperlink from '../subcomponents/Hyperlink'
import { trackEvent } from '../../analytics'

function USBCellularAdapterSetup5(props) {
  const {
    patientManualTapped, trackEventAndPopToTop, t, trackEventAndPop, regionalContentLookup, finishClosesWebView,
  } = props
  return (
    <CommunicatorSetupStep
      stepsImage="step5"
      heading={t('common:usbCellularAdapter')}
      title={t('common:step5SuccessTitle')}
      setupImage="usb_cellular_step_5"
      trackEventAndPop={trackEventAndPop}
      paragraphs={
        [
          <Text style={textStyles.bodyContentText}>{t('common:step5CommunicatorConnected')}</Text>,
          <Text style={textStyles.bodyContentTextBold}>{t('common:troubleshootingSection')}</Text>,
          <Hyperlink
            testID="latitude-patient-manual"
            accessibilityLabel={t('access:patientManualCellDataNetworkPageLink')}
            textStyle={textStyles.bodyContentText}
            beforeText={t('usbCellularStep5Paragraph2Section1')}
            linkText={`${t('usbCellularStep5Paragraph2Section2')} `}
            afterText={t('common:inLatitudePatientManual')}
            onPress={regionalContentLookup('manualURL') ? (() => patientManualTapped('cellDataNetwork')) : null}
          />,
          <Text style={textStyles.bodyContentText}>{t('common:softwareDownloadInstallWarning')}</Text>,
          <Hyperlink
            testID="software-download-and-installation"
            accessibilityLabel={t('access:patientManualSoftwareDownloadPageLink')}
            textStyle={textStyles.bodyContentText}
            beforeText={t('common:referTo')}
            linkText={`${t('common:softwareDownloadAndInstall')} `}
            afterText={t('common:inLatitudePatientManual')}
            onPress={regionalContentLookup('manualURL') ? (() => patientManualTapped('softDownload')) : null}
          />,
          <Hyperlink
            testID="troubleshooting"
            accessibilityLabel={t('access:patientManualTroubleshootingPageLink')}
            textStyle={textStyles.bodyContentText}
            beforeText={t('common:ifNotSolidGreen')}
            linkText={`${t('common:troubleshootingQuoted')} `}
            afterText={t('common:inLatitudePatientManual')}
            onPress={regionalContentLookup('manualURL') ? (() => patientManualTapped('troubleshooting')) : null}
          />,
        ]
      }
      finishTapped={() => {
        if (finishClosesWebView && window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage('pop')
          trackEvent('finish')
        } else {
          trackEventAndPopToTop('finish')
        }
      }}
      accessibilityLabel={t('access:cellAdapterStep5Page')}
      testID="USBCellularSetup5"
      moreInformationAnalyticsEventDescription="USBCellularStep5"
      t={t}
    />
  )
}

USBCellularAdapterSetup5.propTypes = {
  patientManualTapped: PropTypes.func.isRequired,
  trackEventAndPopToTop: PropTypes.func.isRequired,
  trackEventAndPop: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  regionalContentLookup: PropTypes.func.isRequired,
  finishClosesWebView: PropTypes.bool.isRequired,
}

const actionCreators = {
  patientManualTapped: tapevent.patientManualTapped,
  trackEventAndPopToTop: helpers.trackEventAndPopToTop,
  trackEventAndPop: helpers.trackEventAndPop,
  regionalContentLookup: regionalLookup.regionalContentLookup,
}

export const USBCellularAdapterSetup5Component = USBCellularAdapterSetup5

export default function getUSBCellularAdapterStep5(finishClosesWebView) {
  return withTranslation(['communicatorSetup', 'common'])(connect(() => ({ finishClosesWebView }), actionCreators)(USBCellularAdapterSetup5))
}
